export default __webpack_public_path__ + "static/media/iconCamera2.6aac2e4d.svg";